//@@ Constants
import { METRIC_TYPE } from '@src/views/apps/reports/constants'

//@@ Components
import { DatabaseWrapper } from '@src/views/apps/reports/features/Database/components/DatabaseWrapper/DatabaseWrapper'

export const JourneyDatabase = () => {
  return <DatabaseWrapper type={METRIC_TYPE.journey} />
}
